module.exports = __webpack_public_path__ + "img/developers--avatar.6d16d6b9.svg";